import { render, staticRenderFns } from "./TaxonSelectorPanel.vue?vue&type=template&id=1d05b559&scoped=true"
import script from "./TaxonSelectorPanel.vue?vue&type=script&lang=js"
export * from "./TaxonSelectorPanel.vue?vue&type=script&lang=js"
import style0 from "./TaxonSelectorPanel.vue?vue&type=style&index=0&id=1d05b559&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d05b559",
  null
  
)

export default component.exports